import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "link-dialog" }
const _hoisted_2 = { class: "tabs" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 2,
  class: "preview"
}
const _hoisted_5 = { class: "btns" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Input = _resolveComponent("Input")!
  const _component_SelectOption = _resolveComponent("SelectOption")!
  const _component_Select = _resolveComponent("Select")!
  const _component_ThumbnailSlide = _resolveComponent("ThumbnailSlide")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["tab", { 'active': _ctx.type === tab.key }]),
          key: tab.key,
          onClick: ($event: any) => (_ctx.type = tab.key)
        }, _toDisplayString(tab.label), 11, _hoisted_3))
      }), 128))
    ]),
    (_ctx.type === 'web')
      ? (_openBlock(), _createBlock(_component_Input, {
          key: 0,
          class: "input",
          value: _ctx.address,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.address) = $event)),
          placeholder: "请输入网页链接地址"
        }, null, 8, ["value"]))
      : _createCommentVNode("", true),
    (_ctx.type === 'slide')
      ? (_openBlock(), _createBlock(_component_Select, {
          key: 1,
          class: "input",
          value: _ctx.slideId,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.slideId) = $event))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slides, (slide, index) => {
              return (_openBlock(), _createBlock(_component_SelectOption, {
                key: slide.id,
                value: slide.id
              }, {
                default: _withCtx(() => [
                  _createTextVNode("幻灯片 " + _toDisplayString(index + 1), 1)
                ]),
                _: 2
              }, 1032, ["value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["value"]))
      : _createCommentVNode("", true),
    (_ctx.type === 'slide' && _ctx.selectedSlide)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _cache[4] || (_cache[4] = _createElementVNode("div", null, "预览：", -1)),
          _createVNode(_component_ThumbnailSlide, {
            class: "thumbnail",
            slide: _ctx.selectedSlide,
            size: 490
          }, null, 8, ["slide"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_Button, {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.close())),
        style: {"margin-right":"10px"}
      }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [
          _createTextVNode("取消")
        ])),
        _: 1
      }),
      _createVNode(_component_Button, {
        type: "primary",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.save()))
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [
          _createTextVNode("确认")
        ])),
        _: 1
      })
    ])
  ]))
}